export default ".profileIn {\n  text-align: end;\n}\n\nh5.modoAdm {\n  color: red;\n}\n\n.divHide {\n  display: none;\n}";